<template>
    <div class="de-rank-prop">
        <Col class="item">
            <span class="text">序号：</span>
            <Textprop :value="key" @input="(val) => change(val, 'key')" class="inline"></Textprop>
        </Col>
        <Col class="item">
            <span class="text">标题：</span>
            <Textprop :value="option" @input="(val) => change(val, 'option')" class="inline"></Textprop>
        </Col>
        <Col class="item">
            <span class="text">比例：</span>
            <number :value="percent" @input="(val) => change(val, 'percent')"></number>
        </Col>
        <Col class="item">
            <span class="text">柱子颜色：</span>
            <color :value="color" @input="(val) => change(val, 'color')"></color>
        </Col>
        <Col class="item">
            <span class="text">总数：</span>
            <number :value="total" @input="(val) => change(val, 'total')"></number>
        </Col>
    </div>
</template>

<script>
import Number from './number-prop';
import Color from './color-prop';
import Textprop from './text-prop';
let obj = null;

export default {
    name: 'de-rank-prop',
    components: {
        Number,
        Color,
        Textprop
    },
    props: {
        value: {
            type: Object
        }
    },
    data() {
        return {
            key: 1,
            option: '标题',
            percent: 50,
            color: 'linear-gradient(-45deg, #038CFB 0%, #102FA8 100%)',
            total: 4232
        }
    },
    watch: {
        value:{
            handler(value){
                if(value){
                    this.key = value.key,
                    this.option = value.option,
                    this.percent = value.percent,
                    this.color = value.color,
                    this.total = value.total,
                    obj = Object.assign({}, value);
                }
            },
            immediate:true
        }
    },
    methods: {
        change(val, name){
            obj[name] = val;
            this.$emit("input", obj);
            this.$emit('save');
        }
    }
}
</script>

<style lang="less">
.de-rank-prop {
    .inline {
        display: inline-block;
        width: 60%
    }
    .item {
        padding-top: 12px;
    }
    .item:first-child {
        padding-top: 0;
    }
}
</style>